export const IconTelephone = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3083 15.2748C18.3083 15.5748 18.2416 15.8832 18.1 16.1832C17.9583 16.4832 17.775 16.7665 17.5333 17.0332C17.125 17.4832 16.675 17.8082 16.1666 18.0165C15.6666 18.2248 15.125 18.3332 14.5416 18.3332C13.6916 18.3332 12.7833 18.1332 11.825 17.7248C10.8666 17.3165 9.90829 16.7665 8.95829 16.0748C7.99996 15.3748 7.09163 14.5998 6.22496 13.7415C5.36663 12.8748 4.59163 11.9665 3.89996 11.0165C3.21663 10.0665 2.66663 9.1165 2.26663 8.17484C1.86663 7.22484 1.66663 6.3165 1.66663 5.44984C1.66663 4.88317 1.76663 4.3415 1.96663 3.8415C2.16663 3.33317 2.48329 2.8665 2.92496 2.44984C3.45829 1.92484 4.04163 1.6665 4.65829 1.6665C4.89163 1.6665 5.12496 1.7165 5.33329 1.8165C5.54996 1.9165 5.74163 2.0665 5.89163 2.28317L7.82496 5.00817C7.97496 5.2165 8.08329 5.40817 8.15829 5.5915C8.23329 5.7665 8.27496 5.9415 8.27496 6.09984C8.27496 6.29984 8.21663 6.49984 8.09996 6.6915C7.99163 6.88317 7.83329 7.08317 7.63329 7.28317L6.99996 7.9415C6.90829 8.03317 6.86663 8.1415 6.86663 8.27484C6.86663 8.3415 6.87496 8.39984 6.89163 8.4665C6.91663 8.53317 6.94163 8.58317 6.95829 8.63317C7.10829 8.90817 7.36663 9.2665 7.73329 9.69984C8.10829 10.1332 8.50829 10.5748 8.94163 11.0165C9.39163 11.4582 9.82496 11.8665 10.2666 12.2415C10.7 12.6082 11.0583 12.8582 11.3416 13.0082C11.3833 13.0248 11.4333 13.0498 11.4916 13.0748C11.5583 13.0998 11.625 13.1082 11.7 13.1082C11.8416 13.1082 11.95 13.0582 12.0416 12.9665L12.675 12.3415C12.8833 12.1332 13.0833 11.9748 13.275 11.8748C13.4666 11.7582 13.6583 11.6998 13.8666 11.6998C14.025 11.6998 14.1916 11.7332 14.375 11.8082C14.5583 11.8832 14.75 11.9915 14.9583 12.1332L17.7166 14.0915C17.9333 14.2415 18.0833 14.4165 18.175 14.6248C18.2583 14.8332 18.3083 15.0415 18.3083 15.2748Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4167 7.49967C15.4167 6.99967 15.025 6.23301 14.4417 5.60801C13.9083 5.03301 13.2 4.58301 12.5 4.58301"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 7.49984C18.3333 4.27484 15.725 1.6665 12.5 1.6665"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
